import { toast } from 'react-toastify';
import apiClient from '../utils/apiCliente';

export const obtenerPedidosEntregadosSemana = async (userId, rolId, token) => {
	try {
		const response = await apiClient.get('/pedidos/obtenerPedidosEntregadosSemana', {
			params: { usuario_id: userId, rol_id: rolId },
			headers: { Authorization: `Bearer ${token}` },
		});

		return response.data;
	} catch (error) {
		if (error.response) {
			if (error.response.status === 401) {
				toast.info('Su sesión ha expirado. Por favor, inicie sesión nuevamente.', {
					onClose: () => {
						window.location.href = '/login';
					},
				});
			} else if (error.response.status === 403) {
				toast.error('No tiene permisos para acceder a esta información.');
			} else {
				toast.error(
					error.response.data.error || 'Hubo un problema al obtener los pedidos entregados de la semana.',
				);
			}
		} else if (error.request) {
			toast.error('No se pudo establecer conexión con el servidor.');
		} else {
			toast.error('Error al realizar la solicitud.');
		}

		console.error('Error al obtener pedidos entregados:', error);
		throw error;
	}
};
